import { render, staticRenderFns } from "./SettingsAccountForm.vue?vue&type=template&id=7c203bfa"
import script from "./SettingsAccountForm.vue?vue&type=script&lang=js"
export * from "./SettingsAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports